import ReducerConstants from "../../config/ReduxConstant";

const INITIAL_STATE = {};

export const contentWiseLoSeedData = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ReducerConstants.SET_CONTENT_WISE_LO_SEED_DATA:
            const { courseId, data } = action.payload || {};
            if (courseId) {
                return { ...state, [courseId]: data };
            }
            return state;
        default:
            return state
    }
}